import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  const {
    type: actionType,
    payload,
  } = action

  switch (actionType) {
    case actions.AMBASSADORS_SET_PAYOUT_PROCESSING: {
      const { processing } = payload
      return state.setIn(['payouts', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_PAYOUT: {
      const { data, error } = payload
      return state.set('payouts', fromJS(data))
        .setIn(['payouts', 'processing'], false)
        .setIn(['payouts', 'error'], error)
        .set('processing', false)
    }
    case actions.AMBASSADORS_SET_DETAILS: {
      const { data, error } = payload
      return state.set('data', fromJS(data))
        .set('processing', false)
        .set('error', error)
    }
    case actions.AMBASSADORS_SET_CAMPAIGNS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['campaigns', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_CAMPAIGNS: {
      const { data, error } = payload
      return state.setIn(['campaigns', 'data'], fromJS(data))
        .setIn(['campaigns', 'processing'], false)
        .setIn(['campaigns', 'error'], error)
    }
    case actions.AMBASSADORS_SET_UPCOMING_CAMPAIGNS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['upcomingCampaigns', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_UPCOMING_CAMPAIGNS: {
      const { data, error } = payload
      return state.setIn(['upcomingCampaigns', 'data'], fromJS(data))
        .setIn(['upcomingCampaigns', 'processing'], false)
        .setIn(['upcomingCampaigns', 'error'], error)
    }
    case actions.AMBASSADORS_SET_SIGNUPS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['signups', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_SIGNUPS: {
      const { data, error } = payload
      return state.set('signups', fromJS(data))
        .setIn(['signups', 'processing'], false)
        .setIn(['signups', 'error'], error)
    }
    case actions.AMBASSADORS_SET_CAMPAIGN_DETAILS_PROCESSING: {
      const { processing } = payload
      return state.setIn(['campaignDetails', 'processing'], processing)
    }
    case actions.AMBASSADORS_SET_CAMPAIGN_DETAILS: {
      const { data, error } = payload
      return state.setIn(['campaignDetails', 'data'], fromJS(data))
        .setIn(['campaignDetails', 'processing'], false)
        .setIn(['campaignDetails', 'error'], error)
    }

    default:
      return state
  }
}
